import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  CommandDialog,
  CommandInput,
  CommandList,
  CommandEmpty,
  CommandGroup,
  CommandItem,
} from "../ui/command";
import { DialogTitle, DialogDescription } from "../ui/dialog";
import {
  LayoutDashboard,
  Network,
  UserSearch,
  Clock4,
  MessageSquareHeart,
  Pill,
  ShieldCheck,
  GitCompareArrows,
} from "lucide-react";

const COMMANDS = [
  { label: "Dashboard — Funnel agregado", to: "/", icon: LayoutDashboard },
  { label: "Detalle por Ámbito", to: "/ambitos", icon: Network },
  { label: "Viaje Individual del Paciente", to: "/paciente", icon: UserSearch },
  { label: "Tiempos Internos", to: "/tiempos", icon: Clock4 },
  { label: "Contactabilidad", to: "/contactabilidad", icon: MessageSquareHeart },
  { label: "Farmacia y Medicamentos", to: "/farmacia", icon: Pill },
  { label: "Seguros y Planes UC", to: "/seguros", icon: ShieldCheck },
  { label: "Comparativa de Períodos", to: "/comparativa", icon: GitCompareArrows },
];

export default function CommandPalette({ open, setOpen }) {
  const navigate = useNavigate();

  useEffect(() => {
    const down = (e) => {
      if ((e.key === "k" || e.key === "K") && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        setOpen(!open);
      }
    };
    document.addEventListener("keydown", down);
    return () => document.removeEventListener("keydown", down);
  }, [open, setOpen]);

  const go = (to) => {
    setOpen(false);
    navigate(to);
  };

  return (
    <CommandDialog open={open} onOpenChange={setOpen}>
      <DialogTitle className="sr-only">Paleta de comandos</DialogTitle>
      <DialogDescription className="sr-only">Busca páginas, pacientes y acciones rápidas</DialogDescription>
      <CommandInput placeholder="Buscar páginas, pacientes, acciones..." data-testid="command-input" />
      <CommandList>
        <CommandEmpty>Sin resultados</CommandEmpty>
        <CommandGroup heading="Páginas">
          {COMMANDS.map((c) => (
            <CommandItem
              key={c.to}
              value={c.label}
              onSelect={() => go(c.to)}
              data-testid={`command-${c.to}`}
            >
              <c.icon className="mr-2 h-4 w-4" />
              {c.label}
            </CommandItem>
          ))}
        </CommandGroup>
        <CommandGroup heading="Acciones rápidas">
          <CommandItem onSelect={() => go("/paciente")}>🔍 Buscar paciente por RUT</CommandItem>
          <CommandItem onSelect={() => go("/ambitos")}>📊 Ver ámbito con mayor fuga</CommandItem>
          <CommandItem onSelect={() => go("/comparativa")}>📈 Comparar Q1 2025 vs Q1 2026</CommandItem>
        </CommandGroup>
      </CommandList>
    </CommandDialog>
  );
}
